import {
  BLACK_COLOR,
  AZURE_RADIANCE_COLOR,
  BRIGHT_GREY_COLOR,
  CHARCOAL_BLUE_COLOR,
  CHARCOAL_NAVY_COLOR,
  GREEN_COLOR,
  GUNMETAL_COLOR,
  LIGHT_GRAY_COLOR,
  LIGHT_RED_COLOR,
  PICKLED_BLUEWOOD_COLOR,
  RED_COLOR,
  SKY_BLUE_COLOR,
  WHITE_COLOR,
  LIGHT_GREEN_COLOR,
  BRAND_BLUE,
  DARK_MODE,
  COMET_COLOR,
  OFF_GREY_COLOR,
  BLUE_STROKE_BORDER,
  TRANSPARENT,
  DUST_RED_COLOR,
  BRIGHT_RED_COLOR,
  BRIGHT_BLUE_COLOR,
  BRIGHT_LIGHT_BLUE_COLOR,
  DIM_LIGHT_BLUE_COLOR,
  BLACK_COLOR_25_OPACITY,
  WHITE_COLOR_25_OPACITY,
  COLOR_SELECT_OPEN_LIGHT,
  LIGHT_BLUE,
  BLACK_COLOR_04_OPACITY,
  ERROR_COLOR,
  BLACK_COLOR_60_OPACITY,
  WHITE_COLOR_60_OPACITY,
  LIGHTEST_GRAY_COLOR,
  LIGHTEST_GRAY_COLOR_80_OPACITY,
  CHARCOAL_NAVY_COLOR_80_OPACITY,
  ICE_BLUE_COLOR,
  DEEP_BLUE_COLOR,
  GREEN_SUCCESS_ICON_COLOR,
  DARK_WARNING_COLOR,
  BRIGHT_WARNING_COLOR,
  BLACK_COLOR_88_OPACITY,
  GREEN_SUCCESS_COLOR,
  WHITE_COLOR_20_OPACITY,
  WHITE_COLOR_40_OPACITY,
  BLACK_COLOR_20_OPACITY,
  BLACK_COLOR_40_OPACITY,
} from './constants'

export const customThemeGenerator = (theme) => {
  // console.log('CUSTOM THEME: ', theme)
  return {
    // '--color-loading-overlay': theme == DARK_MODE ? BLACK_COLOR_60_OPACITY : WHITE_COLOR_60_OPACITY,
    '--color-loading-overlay':
      theme == DARK_MODE
        ? CHARCOAL_NAVY_COLOR_80_OPACITY
        : LIGHTEST_GRAY_COLOR_80_OPACITY,
    '--color-loading-text':
      theme == DARK_MODE ? WHITE_COLOR : AZURE_RADIANCE_COLOR,

    '--color-border-custom': theme == DARK_MODE ? COMET_COLOR : OFF_GREY_COLOR,
    '--color-border-selected':
      theme == DARK_MODE ? BLUE_STROKE_BORDER : TRANSPARENT,
    '--color-text-alternate': theme == DARK_MODE ? WHITE_COLOR : BLACK_COLOR,
    // '--color-text-inverse': theme == DARK_MODE ? BLACK_COLOR : WHITE_COLOR,

    '--color-select-open-border':
      theme == DARK_MODE ? WHITE_COLOR : COLOR_SELECT_OPEN_LIGHT,
    '--color-select-dd-item-option-hover':
      theme == DARK_MODE ? LIGHT_BLUE : BLACK_COLOR_04_OPACITY,

    '--color-btn-focus-outline':
      theme == DARK_MODE ? BLUE_STROKE_BORDER : BRIGHT_LIGHT_BLUE_COLOR,
    '--color-input-hover-border':
      theme == DARK_MODE ? LIGHT_GRAY_COLOR : BRIGHT_BLUE_COLOR,

    '--color-form-error-broder':
      theme == DARK_MODE ? DUST_RED_COLOR : BRIGHT_RED_COLOR,

    '--color-form-link-normal':
      theme == DARK_MODE ? DIM_LIGHT_BLUE_COLOR : BRIGHT_LIGHT_BLUE_COLOR,
    '--color-form-link-danger':
      theme == DARK_MODE ? DUST_RED_COLOR : ERROR_COLOR,

    // Scroll Colors
    '--color-table-scroll-bg': theme == DARK_MODE ? CHARCOAL_NAVY_COLOR : WHITE_COLOR,
    '--color-table-scroll-thumb': theme == DARK_MODE ? WHITE_COLOR_25_OPACITY : BLACK_COLOR_25_OPACITY,
    
    '--color-scroll-thumb': theme == DARK_MODE ? WHITE_COLOR_20_OPACITY : BLACK_COLOR_20_OPACITY,
    '--color-scroll-thumb-hover': theme == DARK_MODE ? WHITE_COLOR_40_OPACITY : BLACK_COLOR_40_OPACITY,


    // Sidebar Menu
    '--color-collapsed-menu-item-selected':
      theme == DARK_MODE ? LIGHT_BLUE : ICE_BLUE_COLOR,

    // Table
    '--color-selected-item' : theme == DARK_MODE ? BLUE_STROKE_BORDER : ICE_BLUE_COLOR,

    // Popover / Message
    '--color-popover-bg': theme == DARK_MODE ? CHARCOAL_NAVY_COLOR : WHITE_COLOR,

    // Importers Upload Status
    '--color-sucess-icon': theme == DARK_MODE ? GREEN_SUCCESS_ICON_COLOR : BRIGHT_LIGHT_BLUE_COLOR,
    '--color-success-text': theme == DARK_MODE ? GREEN_SUCCESS_COLOR : BLACK_COLOR_88_OPACITY,
    '--color-warning-icon': theme == DARK_MODE ? DARK_WARNING_COLOR : BRIGHT_WARNING_COLOR,
    '--color-warning-text': theme == DARK_MODE ? DARK_WARNING_COLOR : BLACK_COLOR_88_OPACITY,

    '--color-active-primary': theme == DARK_MODE ? DIM_LIGHT_BLUE_COLOR : BRIGHT_BLUE_COLOR,


    /* '--color-form-focus-border': theme == DARK_MODE ? WHITE_COLOR : BRIGHT_BLUE_COLOR,
    '--color-form-focus-shadow': theme == DARK_MODE ? FOCUS_SHADOW_COLOR_DARK : FOCUS_SHADOW_COLOR_LIGHT,

    '--color-form-focus-border-primary': theme == DARK_MODE ? MILD_BLUE_COLOR : BRIGHT_BLUE_COLOR,
    '--color-form-active-bg-primary': theme == DARK_MODE ? WHITE_COLOR : BRAND_BLUE,
    '--color-form-active-border-primary': theme == DARK_MODE ? DIM_LIGHT_BLUE_COLOR : BRIGHT_BLUE_COLOR, */

    /* '--color-text': theme == DARK_MODE ? WHITE_COLOR : BLACK_COLOR,
    '--color-background-alternate': theme == DARK_MODE ? PICKLED_BLUEWOOD_COLOR : '#666666',
    '--color-background-main': theme == DARK_MODE ? PICKLED_BLUEWOOD_COLOR : OFF_GREY_COLOR,
    '--color-background-collapsible-panel': theme == DARK_MODE ? GUNMETAL_COLOR : BRIGHT_GREY_COLOR,
    '--color-background-vehicle-test-side-panel-header': theme == DARK_MODE ? WHITE_COLOR : BRAND_BLUE,
    '--color-text-vehicle-test-side-panel-header': theme == DARK_MODE ? CHARCOAL_NAVY_COLOR : WHITE_COLOR,
    '--color-connector-preview-background': theme == DARK_MODE ? CHARCOAL_NAVY_COLOR : WHITE_COLOR,
    '--color-collapsable-sidepanel-background-header': theme == DARK_MODE ? WHITE_COLOR : BRAND_BLUE,
    '--color-collapsable-sidepanel-text': theme == DARK_MODE ? BLACK_COLOR : WHITE_COLOR,
    '--color-fill-pinout-table-circuit': theme == DARK_MODE ? WHITE_COLOR : BLACK_COLOR,
    '--color-form-container': theme == DARK_MODE ? CHARCOAL_BLUE_COLOR : WHITE_COLOR,
    '--color-text-editor-container': theme == DARK_MODE ? CHARCOAL_NAVY_COLOR : WHITE_COLOR,

    // dtc status
    '--color-dtc-active': theme == DARK_MODE ? AZURE_RADIANCE_COLOR : SKY_BLUE_COLOR,

    //component status
    '--color-component-indicate': theme == DARK_MODE ? AZURE_RADIANCE_COLOR : SKY_BLUE_COLOR,
    '--color-component-success': theme == DARK_MODE ? GREEN_COLOR : LIGHT_GREEN_COLOR,
    '--color-component-danger': theme == DARK_MODE ? RED_COLOR : LIGHT_RED_COLOR,

    // Repairs by User Report
    '--color-repairs-by-user-card-filtered': theme == DARK_MODE ? AZURE_RADIANCE_COLOR : SKY_BLUE_COLOR,

    //vehicle-config
    '--color-footer-custom': theme == DARK_MODE ? CHARCOAL_NAVY_COLOR : WHITE_COLOR,

    //functional-diagram
    '--color-diagram-edge-hover': theme == DARK_MODE ? SKY_BLUE_COLOR : AZURE_RADIANCE_COLOR,

    '--color-diagram-port-fill': theme == DARK_MODE ? '#3e405a' : '#D9D9D9',
    '--color-diagram-port-stroke': theme == DARK_MODE ? '#475872' : BLACK_COLOR,
    '--color-diagram-port-fill-active': theme == DARK_MODE ? '#0077cc' : '#E0F2FF',
    '--color-diagram-port-stroke-active': AZURE_RADIANCE_COLOR,
    '--color-diagram-port-stroke-hover': theme == DARK_MODE ? SKY_BLUE_COLOR : AZURE_RADIANCE_COLOR,
    '--color-diagram-port-label': theme == DARK_MODE ? WHITE_COLOR : BLACK_COLOR,
    '--color-diagram-port-label-active': theme == DARK_MODE ? WHITE_COLOR : AZURE_RADIANCE_COLOR,

    '--color-diagram-device-fill': theme == DARK_MODE ? '#2b2c3e' : WHITE_COLOR,
    '--color-diagram-device-stroke-unlinkable': theme == DARK_MODE ? '#ff005d' : '#cc004b',
    '--color-diagram-text-fill': theme == DARK_MODE ? WHITE_COLOR : BLACK_COLOR,
    '--color-diagram-text-stroke': theme == DARK_MODE ? CHARCOAL_NAVY_COLOR : LIGHT_GRAY_COLOR,

    //Main Menu
    '--color-card-background-hover': theme == DARK_MODE ? BRAND_BLUE : SKY_BLUE_COLOR,
    '--color-button-child': theme == DARK_MODE ? WHITE_COLOR : BRAND_BLUE, */
  }
}
